import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  delete_restaurant_modal,
  search_restaurants,
  set_restaurants,
} from "src/store/features/restuarant-slice";
import SearchBar from "src/components/common/SearchBar";
import RestaurantCard from "src/components/RestaurantCard/RestaurantCard";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { GET_ALL_RESTAURANTS } from "src/constants/queries";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { useAuth } from "src/contexts/auth-provider";

export const RestaurantPage = () => {
  const { axBe } = useAxiosInterceptor();
  const { userRole, setUser } = useAuth();
  const navigate = useNavigate();
  const isOwner = userRole === "ROLE_ADMIN";
  const { filteredRestaurants } = useSelector(
    (state: any) => state.restaurant
  );
  const dispatch = useDispatch();

  const handleRestaurantClick = (restaurantId: string) => {
    dispatch(delete_restaurant_modal(restaurantId));
  };

  const handleSearchRestaurants = useCallback(
    (query: string) => {
      dispatch(search_restaurants(query));
    },
    [dispatch]
  );

  useEffect(() => {
    const fetchRestaurants = async () => {
      try {
        const response = await axBe.post(GRAPHQL_ENDPOINT, {
          query: GET_ALL_RESTAURANTS,
        });
        const fetchedRestaurants = response.data?.data?.loggedInUserStores;
        if (Array.isArray(fetchedRestaurants)) {
          dispatch(set_restaurants({restaurants: fetchedRestaurants, setUser}));
        } else {
          console.error("Unexpected result structure:", response.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchRestaurants()
  }, [axBe, dispatch, setUser])
  


  return (
    <>
      <div className="mb-6 w-full flex flex-row items-center justify-between gap-3 rounded-lg border border-[#E5E7EB] bg-white px-3 py-2 min-h-[42px]">
        <div className="flex-1 min-w-0 max-w-[260px]">
          <SearchBar
            placeholder="Search by name..."
            onChange={handleSearchRestaurants}
          />
        </div>
        {isOwner && (
          <button
            type="button"
            className="h-8 px-4 rounded-lg text-sm font-medium text-white bg-[#FD7657] hover:bg-[#e45e41] shrink-0 transition-colors"
            onClick={() => navigate("/create-restaurant")}
          >
            Add Restaurant
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2  md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 md:gap-6 gap-3">
        {!filteredRestaurants?.length ? (
          <div className="w-[100%] flex justify-center items-center mt-5 text-[#666666] text-sm">
            <span>No restuantant found</span>
          </div>
        ) : (
          filteredRestaurants.map(
              (restaurant: any) => (<RestaurantCard isDashboard={false} restaurant={restaurant} handleRestaurantClick={handleRestaurantClick} />)
          )
        )}
      </div>
    </>
  );
};